import { productTypes } from "./productTypes";

const INITIAL_STATE = {
  allFactoryOrders: [],
  printableFactoryOrders: [],
  factoryOrdersLoading: false,
  factoryOrdersMeta: {},
  allProducts: [],
  allProductsToPrint: [],
  productsLoading: false,
  productsMeta: {},
  userProducts: [],
  userProductsLoading: false,
  userProductsMeta: {},
  crudLoading: false,
  product: {},
  loading: false,
};

const productReducer = (state = INITIAL_STATE, actions) => {
  switch (actions.type) {
    case productTypes.GET_ALL_FACTORY_ORDERS_START:
      return {
        ...state,
        factoryOrdersLoading: true,
      };
    case productTypes.GET_ALL_FACTORY_ORDERS_SUCCESS:
      return {
        ...state,
        allFactoryOrders: actions.payload,
        printableFactoryOrders: actions.allProducts,
        factoryOrdersMeta: actions.meta,
      };
    case productTypes.GET_ALL_FACTORY_ORDERS_FAILED:
      return {
        ...state,
        factoryOrdersLoading: false,
      };
    case productTypes.GET_ALL_FACTORY_ORDERS_END:
      return {
        ...state,
        factoryOrdersLoading: false,
      };

    //-----------------------printable data
    //   case productTypes.GET_PRINTABLE_FACTORY_ORDERS_START:
    //       return {
    //           ...state,
    //           factoryOrdersLoading: true,
    //       };
    //   case productTypes.GET_PRINTABLE_FACTORY_ORDERS_SUCCESS:
    //       return {
    //           ...state,
    //           printableFactoryOrders: actions.payload,
    //           factoryOrdersMeta: actions.meta,
    //       };
    //   case productTypes.GET_PRINTABLE_FACTORY_ORDERS_FAILED:
    //       return {
    //           ...state,
    //           factoryOrdersLoading: false,
    //       };
    //   case productTypes.GET_PRINTABLE_FACTORY_ORDERS_END:
    //       return {
    //           ...state,
    //           factoryOrdersLoading: false,
    //       };

    //   ---------------- get all products
    case productTypes.GET_ALL_PRODUCT_START:
      return {
        ...state,
        productsLoading: true,
      };
    case productTypes.GET_ALL_PRODUCT_SUCCESS:
      return {
        ...state,
        allProducts: actions.payload,
        allProductsToPrint: actions.allProductsToPrint,
        productsMeta: actions.meta,
      };
    case productTypes.GET_ALL_PRODUCT_FAILED:
      return {
        ...state,
        productsLoading: false,
      };
    case productTypes.GET_ALL_PRODUCT_END:
      return {
        ...state,
        productsLoading: false,
      };

    //   ---------------- get all users products
    case productTypes.GET_ALL_USER_PRODUCT_START:
      return {
        ...state,
        userProductsLoading: true,
      };
    case productTypes.GET_ALL_USER_PRODUCT_SUCCESS:
      return {
        ...state,
        userProducts: actions.payload,
        userProductsMeta: actions.meta,
      };
    case productTypes.GET_ALL_USER_PRODUCT_FAILED:
      return {
        ...state,
        userProductsLoading: false,
      };
    case productTypes.GET_ALL_USER_PRODUCT_END:
      return {
        ...state,
        userProductsLoading: false,
      };

    //create New Product By Admin
    case productTypes.CREATE_NEW_PRODUCT_BY_ADMIN_START:
      return {
        ...state,
        crudLoading: true,
      };
    case productTypes.CREATE_NEW_PRODUCT_BY_ADMIN_SUCCESS:
      return {
        ...state,
        allProducts: actions.payload,
      };
    case productTypes.CREATE_NEW_PRODUCT_BY_ADMIN_FAILED:
      return {
        ...state,
        allProducts: actions.payload,
        crudLoading: false,
      };
    case productTypes.CREATE_NEW_PRODUCT_BY_ADMIN_END:
      return {
        ...state,
        crudLoading: false,
      };

    // update Product By Admin
    case productTypes.UPDATE_NEW_PRODUCT_BY_ADMIN_START:
      return {
        ...state,
        loading: true,
      };
    case productTypes.UPDATE_PRODUCT_BY_ADMIN_SUCCESS:
      return {
        ...state,
        product: actions.payload,
      };
    case productTypes.UPDATE_PRODUCT_BY_ADMIN_FAILED:
      return {
        ...state,
        loading: false,
      };
    case productTypes.UPDATE_PRODUCT_BY_ADMIN_END:
      return {
        ...state,
        loading: false,
      };

    // --------------- DELETE A PRODUCT BY ADMIN
    case productTypes.DELETE_PRODUCT_BY_ADMIN_START:
      return {
        ...state,
        crudLoading: false,
      };
    case productTypes.DELETE_PRODUCT_BY_ADMIN_SUCCESS:
      return {
        ...state,
        allProducts: actions.payload,
      };
    case productTypes.DELETE_PRODUCT_BY_ADMIN_FAILED:
      return {
        ...state,
        allProducts: actions.payload,
        crudLoading: false,
      };
    case productTypes.DELETE_PRODUCT_BY_ADMIN_END:
      return {
        ...state,
        crudLoading: false,
      };
    default:
      return state;
  }
};

export default productReducer;
